import Message from "../../message";
import {useMainStore} from "@/store";
import {cleanupStaleNotifications} from "@/services/notificationCleanup";

export default class ApplicationApproved extends Message
{
    handle()
    {
        useMainStore().REMOVE_GUILD_APPLICATION(this.message.user.id);
        useMainStore().ADD_GUILD_MEMBER(this.message.user);
        useMainStore().SET_GUILD_MEMBER_ONLINE(this.message.user.id);
        cleanupStaleNotifications();
    }
}
